module.exports = {"pagination":{"ListGroupResources":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults","result_key":["ResourceIdentifiers","Resources"]},"ListGroups":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults","result_key":"GroupIdentifiers"},"SearchResources":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults","result_key":"ResourceIdentifiers"}}}


//////////////////
// WEBPACK FOOTER
// ./~/aws-sdk/apis/resource-groups-2017-11-27.paginators.json
// module id = 769
// module chunks = 1